import { render, staticRenderFns } from "./NewOrderAccept.vue?vue&type=template&id=01634e30&"
import script from "./NewOrderAccept.vue?vue&type=script&lang=js&"
export * from "./NewOrderAccept.vue?vue&type=script&lang=js&"
import style0 from "./NewOrderAccept.vue?vue&type=style&index=0&id=01634e30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports